import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const ProfileHeader = ({ storeName, imageUrl }) => {
  const defaultImageUrl = "https://s3-ap-southeast-1.amazonaws.com/bizomcollatorals/15131_59ede754Asset_3@3x.png";
  
  return (
  <Grid container spacing={2} alignItems="center">
    <Grid item xs={12} >
      <Box>
        <img
          src= {imageUrl || defaultImageUrl}
          alt="No Image"
          style={{ width: "100%", maxWidth: "150px" }}
        />
      </Box>
    </Grid>
    <Grid item xs={12} >
      <Typography variant="h1" gutterBottom>
        {storeName}
      </Typography>
    </Grid>
  </Grid>
);
}

export default ProfileHeader;
